module.exports = __webpack_public_path__ + "static/media/loader.79b0c820.svg";